import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Router from 'root/router';
import View from 'view/base';
import Template_Preview_Survey from '../survey_designer/preview';
import Template_Preview_Widget from './preview';
import Template_Sidebar from './sidebar';

import Survey_Model from 'model/survey';
import Survey_Question_Collection from 'collection/survey_question';

var type_labels_feedback = {
    bug: 'Bug',
    feature_request: 'Idea',
    general: 'General',
};

var type_labels_survey = {
    product: 'Product',
    customer: 'Customer',
    marketing: 'Marketing'
};

var Template_Gallery = View.extend({
    views: {
    },

    widget_templates: [],

    selected_type: [],
    initial_template_code: '',
    active_template_index: -1,

    events: {
        'click .template-gallery-filter button' : 'onTypeChange',
        'click .template-cta-preview'           : 'onTemplatePreview',
        'click .template-cta-use'               : 'onTemplateUse',
        'input input[name="search"]'            : 'onSearch',
        'click .start-scratch'                  : 'onStartClick'
    },

    dom_handlers: {
        onTypeChange: function(e) {
            var value = $(e.currentTarget).data('type');

            var index = this.selected_type.indexOf(value);

            if (index === -1) {
                this.selected_type.push(value);
                $(e.currentTarget).removeClass('tertiary').addClass('primary');
            } else {
                this.selected_type.splice(index, 1);
                $(e.currentTarget).removeClass('primary').addClass('tertiary');
            }

            if (this.selected_type.length) {
                this.$el.find('.template-gallery-card').hide();

                this.selected_type.forEach((item) =>{
                    this.$el.find(`.template-gallery-card-${item}`).show();
                });
            } else {
                this.$el.find('.template-gallery-card').show();
            }
        },

        onTemplatePreview: function(e) {
            var template_code = $(e.currentTarget).data('code');
            var index = this.widget_templates.findIndex((template) => template.template_code === template_code);

            if (index === -1) {
                return;
            }

            if (this.active_template_index === -1) {
                this.$el.find('.template-preview').addClass('template-preview-animated');
            };

            this.previewTemplate(index);
        },

        onTemplateUse: function(e) {
            var template_code = $(e.currentTarget).data('code');
            this.useTemplate(template_code);
        },

        onSearch: function(e) {
            var value = $(e.currentTarget).val().toLowerCase();
            this.search_term = value;

            this.renderWidgetTemplates();
        },

        onStartClick: function(e) {
            var template_code;

            if (this.project_type === 'survey') {
                template_code = 'su000';
            } else {
                template_code = 'wt101';
            }

            this.trigger('submit:success', template_code);
        }
    },

    event_handlers: {
        onTemplateClose: function() {
            Router.removeQueryString('template_code');

            this.closeTemplatePreview();
        },

        onTemplateUse: function(template_code) {
            this.useTemplate(template_code);
        },
    },

    closeTemplatePreview: function () {
        this.active_template_index = -1;

        this.$el.find('.template-preview').removeClass('template-preview-expanded template-preview-animated');
    },

    useTemplate: function(template_code) {
        var template = this.widget_templates.find((template) => template.template_code === template_code);

        if (this.show_loader_on_select) {
            this.$el.find('.template-gallery-thumbnail')
                .addClass('disabled')
                .filter('[data-val="' + template_code + '"]').addClass('loading');

            this.$el.find('.start-scratch').prop('disabled', true);
        }

        this.closeTemplatePreview();
        this.trigger('submit:success', template_code, template);
    },

    previewTemplate: function(index) {
        this.active_template_index = index;

        var template = this.widget_templates[index];

        var expanded = this.$el.find('.template-preview').hasClass('template-preview-expanded');

        if (!expanded) {
            this.$el.find('.template-preview').addClass('template-preview-expanded');
        }

        if (this.project_type === 'survey') {
            var survey_questions = new Survey_Question_Collection();
            var survey = new Survey_Model();

            survey_questions.add(template.questions);
            // Go through each question and set the question_key
            survey_questions.forEach((question, index) => {
                const unique_key = 'temp_' + index + '_' + Date.now();
                question.set('question_key', unique_key);
            });

            // Remove the questions from the template object and set the survey data
            const { questions, ...survey_data } = template;
            survey.set(survey_data);

            // Set the data for the preview view
            this.views.preview.setData({
                collection: survey_questions,
                survey: survey,
                mode: 'preview'
            });
        } else {
            this.views.preview.setTemplate(template);
        }

        this.views.sidebar.setTemplate(template, {
            total: this.widget_templates.length,
            index: index,
        });
    },

    getWidgetTemplates: function() {
        var templates = Cache.get('widget_templates');

        if (templates) {
            this.widget_templates = templates;

            this.renderWidgetTemplates();
            return;
        }

        Cache.app.request({
            action: 'widget/getTemplates',
            success: (response) => {
                if (!response) {
                    return;
                }

                this.widget_templates = response;

                Cache.add('widget_templates', response, false);
                this.renderWidgetTemplates();
            }
        });
    },

    getSurveyTemplates: function() {
        var templates = Cache.get('survey_templates');

        if (templates) {
            this.widget_templates = templates;

            this.renderWidgetTemplates();
            return;
        }

        Cache.app.request({
            action: 'survey/getTemplates',
            success: (response) => {
                if (!response) {
                    return;
                }

                this.widget_templates = response;

                Cache.add('survey_templates', response, false);
                this.renderWidgetTemplates();
            }
        });
    },

    getTypeLabels: function() {
        if (this.project_type === 'survey') {
            return type_labels_survey;
        } else {
            return type_labels_feedback;
        }
    },

    renderWidgetTemplates: function() {
        var templates = this.filterTemplates(this.selected_type, this.search_term);
        var cards = '';

        templates.forEach((template) => {
            var type_values = this.getTemplateWorkflowTypes(template).sort();
            var type_classes = type_values.map((item) => `template-gallery-card-${item}`).join(' ');
            var type_text = type_values.map((item) => this.getTypeLabels()[item]).join(', ');
            var bg_img = `/image/template_thumbnails/${this.project_type}/${template.template_thumbnail || template.template_name}.png`;

            cards +=
                '<div class="template-gallery-card ' + type_classes + '">' +
                    '<div class="template-gallery-thumbnail" data-val="' + template.template_code + '" data-type="' + this.project_type + '" style="background-image: url(\''+ bg_img +'\');">' +
                        '<div class="template-gallery-cta flex-c">' +
                            '<button type="button" class="template-cta-preview tertiary small min" data-code="' + template.template_code + '" data-theme="' + this.project_type + '">Preview</button>' +
                            '<button type="button" class="template-cta-use primary small min" data-code="' + template.template_code + '" data-theme="' + this.project_type + '">Use</button>' +
                        '</div>' +
                    '</div>' +
                    '<div class="template-gallery-metadata">' +
                        '<div class="template-gallery-name">' +
                            '<span>' + template.template_name + '</span>' +
                        '</div>' +
                    '</div>' +
                '</div>';
        });

        this.$el.find('.template-gallery-loading').remove();
        this.$el.find('.template-gallery-list').html(cards);
        this.$el.find('.search-result-empty').toggleClass('active', !cards);

        if (this.initial_template_code) {
            var index = this.widget_templates.findIndex((item) => item.template_code === this.initial_template_code);

            if (index !== -1) {
                this.previewTemplate(index);
            }

            this.initial_template_code = '';
        }
    },

    getTemplateWorkflowTypes: function(template) {
        return template.workflow_type ? template.workflow_type.split(',') : [];
    },

    filterTemplates: function(types, search = '') {
        // removed default template (is_scratch)
        // filter next gen
        var templates = this.widget_templates.filter((template) => {
            if (this.project_type === 'survey') {
                return !template.is_scratch;
            } else {
                return !template.is_scratch && template.widget_version === 2;
            }

        });

        if (types.length) {
            templates = this.widget_templates.filter((template) => {
                var type_values = this.getTemplateWorkflowTypes(template);

                return _.intersection(type_values, types).length > 0;
            });
        }

        if (search) {
            templates = templates.filter((template) => {
                return template.template_name.toLowerCase().indexOf(search) !== -1;
            });
        }

        return templates;
    },

    initialize: function(options) {
        this.project_type = options.project_type;
        this.initial_template_code = options.initial_template_code;
        this.show_loader_on_select = !!options.show_loader_on_select;
        this.search_term = '';
        this.selected_type = [];

        var preview_view;
        if (this.project_type === 'survey') {
            var survey_questions = new Survey_Question_Collection();
            var survey = new Survey_Model();

            preview_view = new Template_Preview_Survey({
                collection: survey_questions,
                survey: survey,
                mode: 'preview',
                should_disable_position: true,
                is_gallery: true
            });
        } else {
            preview_view = new Template_Preview_Widget();
        }

        this.views = {
            preview: preview_view,
            sidebar: new Template_Sidebar()
        }

        this.listenTo(this.views.sidebar, 'template:close', this.event_handlers.onTemplateClose);
        this.listenTo(this.views.sidebar, 'template:use', this.event_handlers.onTemplateUse);
    },

    renderFilter: function() {
        var filter_content = '';
        if (this.project_type === 'survey') {
            filter_content +=
            '<div class="search-input-medium search-input-solid">' +
                '<input type="text" name="search" placeholder="Search...">' +
                '<button type="button"><i class="far fa-search"></i></button>' +
            '</div>';
        }

        this.$el.find('.template-gallery-filter').html(filter_content);
    },

    render: function() {
        var content = '';

        content +=
            '<div class="template-gallery-container">' +
                '<div class="template-gallery-filter"></div>' +
                '<button type="button" class="start-scratch tertiary small">Start from scratch</button>' +
                '<div class="template-gallery-loading"><div class="loader"></div></div>' +
                '<div class="template-gallery-list"></div>' +
                '<div class="search-result-empty search-result-empty-large">No templates found</div>' +
            '</div>' +
            '<div class="template-preview">' +
                (this.project_type === 'survey' ? '<div class="template-survey-container"></div>' : '') +
            '</div>';

        this.$el.html(content);

        if (this.project_type === 'survey') {
            this.views.preview.render().$el.appendTo(this.$el.find('.template-survey-container'));
        } else {
            this.views.preview.render().$el.appendTo(this.$el.find('.template-preview'));
        }

        this.views.sidebar.render().$el.appendTo(this.$el.find('.template-preview'));

        this.renderFilter();

        if (this.project_type === 'survey') {
            this.getSurveyTemplates();
        } else {
            this.getWidgetTemplates();
        }

        return this;
    }
});

export default Template_Gallery;
